const MOBILE_BREAKPOINT = 1024

function applyBackground(slide) {
    const desktop = slide.dataset.desktopImg
    const mobile = slide.dataset.mobileSmallImg
    const url = window.innerWidth < MOBILE_BREAKPOINT ? mobile || desktop : desktop

    if (url) {
        slide.style.backgroundImage = `url("${url}")`
    }
}

function syncVideos(root, activeIndex) {
    root.querySelectorAll('.hero-slider__slide').forEach((slide, index) => {
        const video = slide.querySelector('video')
        if (!video) return

        if (index === activeIndex) {
            if (video.preload === 'none') {
                video.preload = 'auto'
                video.load()
            }

            const playing = video.play()
            if (playing && playing.catch) playing.catch(() => {})
        } else {
            video.pause()
        }
    })
}

function syncBullets(root, activeIndex) {
    root.querySelectorAll('.hero-slider__bullet').forEach((bullet, index) => {
        bullet.classList.toggle('hero-slider__bullet--active', index === activeIndex)
    })
}

function initHeroSlider(root) {
    const slides = Array.from(root.querySelectorAll('.hero-slider__slide'))
    if (slides.length === 0) return

    slides.forEach(applyBackground)
    window.addEventListener('resize', () => slides.forEach(applyBackground))

    if (slides.length < 2 || typeof window.Glide === 'undefined') {
        syncVideos(root, 0)
        return
    }

    const glide = new window.Glide(root, {
        type: 'slider',
        perView: 1,
        gap: 0,
        rewind: true,
        autoplay: false,
        keyboard: true,
        dragThreshold: 80,
    })

    glide.on(['mount.after', 'run.after'], () => {
        syncVideos(root, glide.index)
        syncBullets(root, glide.index)
    })

    glide.mount()
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hero-slider').forEach(initHeroSlider)
})
